import React from 'react'
import CmsPageScreen from '../Component/CmsPageScreen'

function Cometee() {
  return <CmsPageScreen pageId={3} contentClassName="text-center" showSubHead={false} />
}

export default Cometee
